import { createStyles, Theme } from '@material-ui/core';

export default (theme: Theme) => createStyles({
  // Expansion Panel Styles
  expandRoot: {
    backgroundColor: '#fefefe',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
  },
  expansionHeader: {
    padding: '16px 24px',
    backgroundColor: '#f8f9fa',
    borderBottom: '1px solid #e9ecef',
  },
  expansionContent: {
    padding: '24px',
    backgroundColor: '#ffffff',
  },
  sectionTitle: {
    fontSize: '24px',
    fontWeight: 600,
    color: '#212529',
    marginRight: '12px',
  },
  deviceCount: {
    backgroundColor: '#DB5C0E',
    color: 'white',
    fontWeight: 600,
  },
  exportButton: {
    color: '#DB5C0E',
    borderColor: '#DB5C0E',
    fontWeight: 600,
    padding: '8px 16px',
    '&:hover': {
      backgroundColor: 'rgba(219, 92, 14, 0.08)',
    },
  },

  // Card Styles
  card: {
    boxShadow: 'none',
    borderRadius: 16,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'all 0.3s ease-in-out',
    border: '1px solid #e9ecef',
    '&:hover': {
      borderColor: '#DB5C0E',
    },
  },
  cardHeader: {
    position: 'relative',
    textAlign: 'center',
    padding: '20px 20px 16px',
    backgroundColor: '#f8f9fa',
    borderRadius: '16px 16px 0 0',
  },
  cardContent: {
    padding: '20px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  liveStatusSection: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    marginBottom: 18,
  },
  statusBadge: {
    position: 'absolute',
    top: '12px',
    right: '12px',
  },
  assignedBadge: {
    backgroundColor: '#28a745',
    color: 'white',
    fontWeight: 600,
  },
  availableBadge: {
    backgroundColor: '#17a2b8',
    color: 'white',
    fontWeight: 600,
  },

  // Icon Styles
  icon: {
    height: 120,
    width: 120,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    margin: '0 auto',
    borderRadius: 8,
    backgroundColor: 'white',
    // border: '2px solid #e9ecef',
  },

  // Customer Section
  customerSection: {
    textAlign: 'center',
    marginBottom: '16px',
  },
  customerLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#6c757d',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '4px',
  },
  customerId: {
    fontSize: '24px',
    fontWeight: 700,
    color: '#DB5C0E',
    lineHeight: 1.2,
  },

  // Divider
  divider: {
    margin: '16px 0',
    backgroundColor: '#e9ecef',
  },

  // Details Section
  detailsSection: {
    flex: 1,
    marginBottom: '20px',
  },
  detailRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '12px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  detailLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#6c757d',
    flex: '0 0 auto',
    marginRight: '12px',
    minWidth: '80px',
  },
  detailValue: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#212529',
    textAlign: 'right',
    flex: 1,
    wordBreak: 'break-word',
  },
  highlightedValue: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#DB5C0E',
    textAlign: 'right',
    flex: 1,
    wordBreak: 'break-word',
  },
  propertyLink: {
    color: '#DB5C0E',
    fontWeight: 600,
    textDecoration: 'none',
    fontSize: '14px',
    '&:hover': {
      textDecoration: 'underline',
    },
  },

  // Action Section
  actionSection: {
    marginTop: 'auto',
  },
  activateButton: {
    backgroundColor: '#DB5C0E',
    color: 'white',
    fontWeight: 600,
    fontSize: '14px',
    padding: '8px 16px',
    borderRadius: 6,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#c5530c',
    },
  },
  maskButton: {
    borderColor: '#6c757d',
    color: '#6c757d',
    fontWeight: 500,
    fontSize: '14px',
    padding: '8px 16px',
    borderRadius: 6,
    textTransform: 'none',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#6c757d',
      color: 'white',
    },
  },

  // Spinner
  spinnerWrapper: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 9999,
  },

  // Legacy styles (keeping for compatibility)
  iconWrapper: {
    textAlign: 'center',
    margin: '15px 0 31px',
    width: '100%',
  },
  primaryText: {
    color: '#DB5C0E',
    fontWeight: 'bold',
    fontSize: 22,
    lineHeight: '28px',
    '& .hubId': {
      fontWeight: 'bold',
      color: '#000',
    },
  },
  secondaryText: {
    fontSize: '16px',
    lineHeight: '20px',
    color: '#979797',
  },
  link: {
    color: '#DB5C0E',
  },
});
